import React from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { useEffect, useState } from "react";
import Select from "react-select";
import { Button } from "../../../common/Button/Button";
import close_modal from "../../../assets/ic_close_modal.svg";

export default function EngagementFiltersModal(props)
{
    return (
        <Modal
          isOpen={props.isOpen}
          onRequestClose={props.toggleModal}
          ariaHideApp={false}
        >
          <ModalContent className="engagement-filter-modal">
            <div className="modal-header-sp">
                <span className="modal-title">Engagement Filters</span>
                <img
                    alt="close"
                    id="Close"
                    src={close_modal}
                    className="close modal-close"
                    onClick={props.toggleModal}
                />
            </div>
            <div className={`modal-body spled-container notes-trail-content custom-scrollbar conv-pl0 conv-pr0`}>
                <div className="row conv-mt15">
                    <div className="col-6">
                        <label className="my-services-model-value">Introductory Conversation:</label>
                        <Select
                            styles={{
                            // Fixes the overlapping problem of the component
                            menu: provided => ({ ...provided, zIndex: 3 })
                            }}
                            placeholder="Select"
                            options={props.ItroductoryConversationOptions}
                            onChange={(option) => {props.onChangeIntroductoryConversationOption(option);}}
                            value={props.selectedIntroductoryConversationOption}
                            isClearable
                            className='react-select-container'
                            classNamePrefix="react-select"
                            theme={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                },
                                })}
                        ></Select>
                    </div>
                    <div className="col-6">
                        <label className="my-services-model-value">Call Status:</label>
                        <Select
                            styles={{
                            // Fixes the overlapping problem of the component
                            menu: provided => ({ ...provided, zIndex: 3 })
                            }}
                            placeholder="Select"
                            options={props.callStatusOptions}
                            onChange={(option) => {props.onChangeCallStatusOption(option);}}
                            value={props.selectedCallStatusOption}
                            isClearable
                            className='react-select-container'
                            classNamePrefix="react-select"
                            theme={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                },
                                })}
                        ></Select>
                    </div>
                </div>
                <div className="row conv-mt15">
                    <div className="col-6">
                        <label className="my-services-model-value">Stay Engaged With deAsra:</label>
                        <Select
                            styles={{
                            // Fixes the overlapping problem of the component
                            menu: provided => ({ ...provided, zIndex: 3 })
                            }}
                            placeholder="Select"
                            options={props.StayEnagegedOptions}
                            onChange={(option) => {props.onChangeStayEnagegedOption(option);}}
                            value={props.selectedStayEnagegedOption}
                            isClearable
                            className='react-select-container'
                            classNamePrefix="react-select"
                            theme={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                },
                                })}
                        ></Select>
                    </div>
                    <div className="col-6">
                        <label className="my-services-model-value">Shared Challenges/Goals?</label>
                        <Select
                            styles={{
                            // Fixes the overlapping problem of the component
                            menu: provided => ({ ...provided, zIndex: 3 })
                            }}
                            placeholder="Select"
                            options={props.userSharedChallegesGoalsOptions}
                            onChange={(option) => {props.onChangeuserSharedChallegesGoalsOption(option);}}
                            value={props.selecteduserSharedChallegesGoalsOption}
                            isClearable
                            className='react-select-container'
                            classNamePrefix="react-select"
                            theme={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                },
                                })}
                        ></Select>
                    </div>
                </div>
                <div className="row conv-mt15">
                    <div className="col-6">
                        <label className="my-services-model-value">Can deAsra Help?</label>
                        <Select
                            styles={{
                            // Fixes the overlapping problem of the component
                            menu: provided => ({ ...provided, zIndex: 3 })
                            }}
                            placeholder="Select"
                            options={props.deAsraAbleHelpforChallegesGoalsOptions}
                            onChange={(option) => {props.onChangedeAsraAbleHelpforChallegesGoalsOption(option);}}
                            value={props.selecteddeAsraAbleHelpforChallegesGoalsOption}
                            isClearable
                            className='react-select-container'
                            classNamePrefix="react-select"
                            theme={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                },
                                })}
                        ></Select>
                    </div>                   
                </div>
                <div className="row conv-mt20">
                  <div className="col-12 lpm-modal-bottom-action bottom-action">
                      <button 
                          type="button" 
                          className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
                          onClick={(e) =>props.onEngagementFilterSearchClicked(e)}>
                          Apply
                      </button>
  
                      <button 
                          type="button" 
                          className="lpm-con-btn-bordered-filter conv-float-right conv-mr25 conv-pr25 conv-pl25"
                          onClick={(e) =>props.onClearEngagementFilterClicked(e)}>
                          Clear All
                      </button>
                  </div>
              </div>
                    
            </div>
          </ModalContent>
        </Modal>
      );
}